module.exports = "pegasus_template/assets/preview-15.png";